import * as React from 'react';

import Box from '@mui/material/Box';

import ImgLooking1 from '../../assets/looking-1.png';
import ImgLooking2 from '../../assets/looking-2.png';
import ImgLooking3 from '../../assets/looking-3.png';
import ImgLooking4 from '../../assets/looking-4.png';

const qualities = [
  {
    title: 'Excellent Communication and Team Spirit',
    shadowClass: "shadow-blue",
    image: ImgLooking1,
    description:
      'Communicates effectively with stakeholders, builds meaningful working relationships and contributes positively to the team.',
  },
  {
    title: 'Strong Drive and Ownership',
    shadowClass: "shadow-blue",
    image: ImgLooking2,
    description:
      'Takes ownership, follows through on commitments and consistently pushes for excellence.',
  },
  {
    title: 'Sharp Analytical Thinking',
    shadowClass: "shadow-blue",
    image: ImgLooking3,
    description:
      'Approaches problems with agility, develops practical solutions, exercises sound judgment and maintains high standards of quality.',
  },
  {
    title: 'Adaptability and a Self-Starter Mindset',
    shadowClass: "shadow-blue",
    image: ImgLooking4,
    description:
      'Thrives in dynamic environments, remains open-minded, takes initiative and manages multiple deliverables and shifting priorities effectively.',
  },
];

export default function Looking(){
    return (
        <Box className="wrapper looking-for" id='looking-for'>
            

            <h2 className="section-title">Who Are We Seeking</h2>

            {/*
            <p className="desc">We are seeking driven and motivated talents who are passionate about embarking on an impactful career which is at the intersection between finance and technology. We highly value talents who demonstrate resilience, adaptability, and a keen interest in the technology industry.</p>
            <Box className="requirements">Calling out to all prospective and recent graduates with:</Box>
                <p className="item">A recognised Bachelor's degree or higher in Accountancy, Finance, or a related field, with strong academic credentials.</p>
                <p className="item">
                    0 to 2 years of relevant full-time working experience in accounting or finance-related roles (as of 31 October 2026)*.
                </p>
                <p className="item">An excellent communicator who can effectively engage with stakeholders at all levels and build meaningful interpersonal relationships.</p>
                <p className="item">A highly motivated professional who excels in fast-paced environments, consistently managing multiple tasks and adapting effectively to shifting priorities and deadlines.</p>
                <p className="item">A dynamic individual with analytical dexterity and problem solving aptitude, with a strong determination to drive positive outcomes.</p>
                <p className="item">An independent self-starter who possesses an open-minded attitude and exemplifies excellent teamwork.</p>
                <Box className="requirements">*You should have completed or be on track to complete your degree no later than July 2027, and are able to join us full-time by August 2027.</Box>
            */}
            <p className="desc">We are looking for driven individuals who are passionate about building an impactful career at the intersection of Finance and Technology.</p>
            <p className="desc">Graduates with a recognised Bachelor's degree or higher* in Accounting, Finance, Computer Science, Data, Al or related fields, with 0 to 2 years of relevant full-time working experience (as of the last day of the application window) are welcome to apply!</p>
            <p className="desc">*You should have completed or be on track to complete your degree no later than July 2027, and are able to join us full-time by August 2027.</p>

            <Box className="requirements">We want you to be part of our team if you possess:</Box>
            <div className="looking-for__container">
                {qualities.map((item) => (
                    <div className={`looking-for__card ${item.shadowClass}`} key={item.title}>
                        <div className="looking-for__icon">
                            <img src={item.image} alt={item.title} />
                        </div>
                        <p className="looking-for__title"> {item.title} </p>
                        <p className="looking-for__description"> {item.description} </p>
                    </div>
                ))}
            </div>
        </Box>
    );
}